import { Context } from '@nuxt/types';

export default async function(context: Context) {
  const { store } = context;

  await store.dispatch('getTokenMigrationStatus');
}
